<button mat-icon-button class="close-button" (click)="close()">
  <mat-icon class="close-icon" color="warn">close</mat-icon>
</button>
<h1 matDialogTitle>{{data.title}}</h1>
<div mat-dialog-content>
    <mat-card class="p-0">
        
            <div fxLayout="row wrap" fxLayout.lt-sm="column">
              <div fxFlex="100" class="pr-1"><br></div>
              <div fxFlex="100" class="pr-1">
                <button mat-raised-button class="mb-05" color="primary"
                  (click)="$event.preventDefault(); popUpEndereco({}, true)">{{"ADD" | translate }} {{"ENDERECO" | translate
                  }}
                </button>
                <br>
              </div>
              <div fxFlex="100" class="pr-1">
    
                <ngx-datatable class="material ml-0 mr-0" [rows]="enderecos" [headerHeight]="50" [footerHeight]="50"
                  [scrollbarH]="true" [messages]="{emptyMessage:'Nenhum Endereço encontrado'}" [limit]="pageSizeEndereco"
                  [rowHeight]="50">
                  <ngx-datatable-column name="#" [width]="25">
                    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                      <strong>{{ rowIndex+1 }}</strong>
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column name="Opções" [flexGrow]="1" [width]="100">
                    <ng-template let-row="row" ngx-datatable-cell-template>
                      <button mat-icon-button mat-sm-button color="primary" class="mr-1"
                        (click)="$event.preventDefault();popUpEndereco(row)">
                        <mat-icon>edit</mat-icon>
                      </button>
                      <button mat-icon-button mat-sm-button color="warn"
                        (click)="$event.preventDefault();deleteEndereco(row)">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </ng-template>
                  </ngx-datatable-column>
    
                  <ngx-datatable-column name="CEP" [flexGrow]="1" [width]="120">
                    <ng-template let-row="row" ngx-datatable-cell-template>
                      {{ row?.cep }}
                    </ng-template>
                  </ngx-datatable-column>
    
                  <ngx-datatable-column name="Endereço" [flexGrow]="1" [width]="200">
                    <ng-template let-row="row" ngx-datatable-cell-template>
                      {{row?.endereco}}
                    </ng-template>
                  </ngx-datatable-column>
    
                  <ngx-datatable-column name="Numero" [flexGrow]="1" [width]="75">
                    <ng-template let-row="row" ngx-datatable-cell-template>
                      {{ row?.numero }}
                    </ng-template>
                  </ngx-datatable-column>
    
                  <ngx-datatable-column name="Bairro" [flexGrow]="1" [width]="120">
                    <ng-template let-row="row" ngx-datatable-cell-template>
                      {{ row?.bairro }}
                    </ng-template>
                  </ngx-datatable-column>
    
                  <ngx-datatable-column name="Cidade" [flexGrow]="1" [width]="200">
                    <ng-template let-row="row" ngx-datatable-cell-template>
                      <span *ngIf="row && row.cadMun">{{ row?.cadMun?.municipio + '-' + row?.cadMun?.uf }}</span>
                    </ng-template>
                  </ngx-datatable-column>
    
                  <ngx-datatable-footer>
                    <ng-template ngx-datatable-footer-template>
                      <mat-paginator #paginatorEndereco [length]="length" fxLayoutAlign="space-around center"
                        [showFirstLastButtons]="true" [pageSize]="pageSizeEndereco"
                        [pageSizeOptions]="pageSizeOptionsEndereco"
                        (page)="pageEventEndereco = setPageSizeOptionsEndereco($event)">
                      </mat-paginator>
                    </ng-template>
                  </ngx-datatable-footer>
                </ngx-datatable>
              </div>
            </div>
          
    </mat-card>
</div>
<mat-dialog-actions>
    <div fxFlex="100" class="mt-1">
        <span fxFlex></span>
        <button mat-button color="warn" type="button" (click)="close()"><mat-icon>close</mat-icon>{{"CLOSE" | translate }}</button>
    </div>
</mat-dialog-actions>